
import LayoutFooter from '../components/layout/footers.vue'
import LayoutHeader from '../components/layout/header.vue'
export default {
  async asyncData({ app, store, error }) {
    if (!process.server) return
  },
  name: "default",
  components: { LayoutFooter, LayoutHeader }
}
